module.exports = __webpack_public_path__ + "img/no_3.be840d0e.png";